import PropTypes from 'prop-types';
import { FUNNELS } from './util/constants';
export const inputDefault = {
  name: '',
  value: {},
  onBlur: (e, value) => {},
  onChange: (e, value) => {}
};
export const fieldDefault = {
  name: '',
  value: {},
  onBlur: () => {},
  onChange: value => {}
};
const validInputModes = ['text', 'search', 'none', 'tel', 'url', 'email', 'numeric', 'decimal'];
export const defaultFieldPropTypes = {
  funnel: FUNNELS.ARHI,
  help: '',
  width: 20,
  optional: false
};
//Needs to be only as we still have js components left so they will still build
export const fieldPropTypes = {
  funnel: PropTypes.oneOf(Object.values(FUNNELS)),
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
  validated: PropTypes.bool,
  width: PropTypes.number,
  // from redux-form
  input: PropTypes.object,
  meta: PropTypes.object,
  // from formik
  field: PropTypes.object,
  form: PropTypes.object,
  optional: PropTypes.bool
};